<template>
  <div class="tw-flex tw-flex-col tw-gap-5 tw-p-1 tw-bg-transparent tw-min-w-[242px] tw-max-w-[242px]">
    <!-- <AdvisorCorePortfolioToggles /> -->

    <AdvisorCoreNavGroup
      v-if="checkupStore.areas?.length || checkupStore.isLoading"
      name="Portfolios"
    >
      <PortfolioToggle
        v-if="checkupStore.portfolio"
        :portfolio="checkupStore.portfolio"
        :checked="checkupStore.portfolio.isChecked"
        :color="advisorStore.firmAdvisorCoreSettings.portfolio_color"
        @onChecked="(value) => setIsCheckedPortfolio(value, checkupStore.portfolio)"
      />
      <PortfolioToggle
        v-if="checkupStore.benchmark"
        :portfolio="checkupStore.benchmark"
        :checked="checkupStore.benchmark.isChecked"
        :color="advisorStore.firmAdvisorCoreSettings.benchmark_color"
        @onChecked="(value) => setIsCheckedPortfolio(value, checkupStore.benchmark)"
      />
      <OptimizedPortfolioToggle
        v-if="checkupStore.isOptimizationLoading || checkupStore.optimizedPortfolio"
        :portfolio="checkupStore.optimizedPortfolio"
        :color="advisorStore.firmAdvisorCoreSettings.proposed_color"
        @onChecked="(value) => setIsCheckedPortfolio(value, checkupStore.optimizedPortfolio)"
      />
      <!-- <PortfolioToggle :portfolio="checkupStore.optimizedPortfolio" :color="advisorStore.firmAdvisorCoreSettings.proposed_color" /> -->
    </AdvisorCoreNavGroup>

    <AdvisorCoreNavGroup name="Pages">
      <AdvisorCoreNavLink page="Start" />
      <AdvisorCoreNavLink
        v-if="checkupStore.holdingsFromPortfolios?.length > 0 || checkupStore.benchmark || checkupStore.optimizedPortfolio"
        page="Holdings"
      >
        Holdings
      </AdvisorCoreNavLink>
      <template v-if="areAnyPortfoliosChecked">
      <AdvisorCoreNavLink
        v-if="checkupStore.areas?.length > 1"
        page="Overview"
      />

      <!-- <AdvisorCoreNavLink
        v-if="showExecutiveSummaryLink"
        page="Executive Summary"
      /> -->

      <AdvisorCoreNavLink
        v-if="checkupStore.optimization?.optimizations?.length && (checkupStore.isOptimizationLoading || checkupStore.optimizedPortfolio?.isChecked)"
        page="Optimization"
      />

      <template v-if="analyticsPages?.length">
        <AdvisorCoreNavLink
          v-for="page in analyticsPages"
          :key="page"
          :page="page"
          :display="DISPLAY_NAMES[page]"
        />
      </template>
      <AdvisorCoreNavLink
        v-if="analyticsPages?.length && checkupStore.portfolio && checkupStore.portfolio.uploaded_df_agg?.length && checkupStore.portfolio.uploaded_df_agg.some(item => ['Taxable', 'Tax Deferred', 'Tax Free'].includes(item.account_tax_status))"
        page="Asset Location"
      />
      <AdvisorCoreNavLink
        v-if="checkupStore.portfolio && typeof checkupStore.optimizedPortfolio?.external_id === 'string' && checkupStore.optimizedPortfolio?.external_id.startsWith('entity_')"
        page="Tax Transition"
      />
      <AdvisorCoreNavLink
        v-if="analyticsPages?.length && checkupStore.featureFlags.includes('Feature: Stress Test')"
        page="Stress Test"
      />
      </template>
    </AdvisorCoreNavGroup>

    <AdvisorCoreNavGroup
      name="Customization"
    >
      <AdvisorCoreNavLink page="Settings" />
    </AdvisorCoreNavGroup>

    <AdvisorCoreExport v-if="checkupStore.areas.length > 0" />
  </div>
</template>


<script>
// import AdvisorCorePortfolioToggles from './AdvisorCorePortfolioToggles.vue';
import AdvisorCoreNavGroup from './AdvisorCoreNavGroup.vue';
import AdvisorCoreNavLink from './AdvisorCoreNavLink.vue';
import AdvisorCoreExport from './AdvisorCoreExport.vue';
import PortfolioToggle from './PortfolioToggle.vue';
import OptimizedPortfolioToggle from './OptimizedPortfolioToggle.vue';
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';

// If you want to use a custom display name for on of the analyticsPages, add it here.
const DISPLAY_NAMES = {
  // asset-class: 'Custom Asset Class Name',
};


export default {
  name: 'AdvisorCoreNav',
  components: {
    // AdvisorCorePortfolioToggles,
    AdvisorCoreNavGroup,
    AdvisorCoreNavLink,
    AdvisorCoreExport,
    PortfolioToggle,
    OptimizedPortfolioToggle,
  },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { DISPLAY_NAMES };
  },
  computed: {
    ...mapStores(useCheckupStore, useAdvisorStore),
    analyticsPages() {
      return this.checkupStore.areas
        .filter(area => {
          if (area.name === 'Trailing Returns') return false;
          if (area.name === 'Extended Style Breakdown') return false;
          if (area.name === 'Asset Location') return false;
          if (area.name === 'Values Alignment' && !(this.checkupStore.selectedValueIds && this.checkupStore.selectedValueIds?.length)) return false;
          return true;
        })
        .map(area => area.name);
    },
    hasUnmatchedHoldings() {
      console.log('from', this.checkupStore.holdingsFromPortfolios);
      console.log('selected', this.checkupStore.selectedPortfolios);
      return this.checkupStore.selectedPortfolios?.some(portfolio => portfolio.unmatched_holdings?.length > 0);
    },
    showExecutiveSummaryLink() {
      // Use this to control when the link appears
      // Should return true or false
      // For example, if you only want it to show after analysis is done:
      // return this.checkupStore.areas?.length > 1
      return true;
    },
    showAssetLocationLink() {
      return true;
    },
    showAssetLocationAdvancedLink() {
      return true;
    },
    areAnyPortfoliosChecked() {
      return [
        this.checkupStore.portfolio?.isChecked,
        this.checkupStore.benchmark?.isChecked,
        this.checkupStore.optimizedPortfolio?.isChecked,
      ].some(Boolean);
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    setIsCheckedPortfolio(value, portfolio) {
      this.checkupStore.updatePortfolio({ ...portfolio, isChecked: value });
      this.$emit('onPortfolioToggle');
    },
  },
};
</script>


<style scoped>

</style>
